
import React from 'react';

interface ChangeItem {
  type: 'update' | 'fault';
  title: string;
  description: string;
  status?: 'fixed' | 'progress' | 'investigating';
}

const Changelog: React.FC = () => {
  const data: ChangeItem[] = [
    {
      type: 'update',
      title: 'Analytics & Compliance',
      description: 'Integrated Google Analytics and UK-compliant cookie consent banner with granular control.',
    },
    {
      type: 'update',
      title: 'Hardware & Pixel Sync',
      description: 'Added dynamic panel resolution, custom pixel pitches, and bidirectional physical-to-pixel validation.',
    },
    {
      type: 'update',
      title: 'Ratio Logic & Sync',
      description: 'Implemented real-time W:H to decimal sync and refined input masking for custom fields.',
      status: 'fixed'
    },
    {
      type: 'update',
      title: 'UI & Input Controls',
      description: 'Added read-only states for presets and smart increment/decrement arrows for layout inputs.',
    },
    {
      type: 'update',
      title: 'Calculation Precision',
      description: 'Refined accuracy scoring engine and added "Actual" vs "Closest Pixel" rounding toggles.',
    },
    {
      type: 'update',
      title: 'Fill Canvas Mapping',
      description: 'Replaced percentage Zoom metrics with absolute Canvas Fill dimensions for media server config.',
    }
  ];

  const getStatusDot = (status?: string, type?: string) => {
    if (type === 'update') return 'bg-blue-500';
    switch (status) {
      case 'fixed': return 'bg-emerald-500';
      case 'progress': return 'bg-[#ff8000]';
      case 'investigating': return 'bg-rose-500';
      default: return 'bg-slate-600';
    }
  };

  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-4 w-full">
      <header className="flex items-center gap-2 mb-3 border-b border-slate-800 pb-2">
        <div className="w-1.5 h-1.5 rounded-full bg-[#ff8000] animate-pulse"></div>
        <h4 className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em]">System Status & Dev Log</h4>
      </header>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
        {data.map((item, i) => (
          <div key={i} className="flex gap-3 group">
            <div className={`w-1 h-1 rounded-full mt-1.5 shrink-0 ${getStatusDot(item.status, item.type)}`}></div>
            <div className="space-y-0.5">
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-bold text-slate-200 group-hover:text-white transition-colors">
                  {item.title}
                </span>
                {item.status && (
                  <span className="text-[7px] font-black uppercase tracking-tighter text-slate-500">
                    [{item.status}]
                  </span>
                )}
              </div>
              <p className="text-[9px] text-slate-500 leading-tight">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Changelog;
